import { render } from "./MediaRoll.vue?vue&type=template&id=4ba4f89e"
import script from "./MediaRoll.vue?vue&type=script&lang=js"
export * from "./MediaRoll.vue?vue&type=script&lang=js"

import exportComponent from "D:\\AlterLau\\walter-main\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__